$('.featured-developments-slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    centerMode: false,
    variableWidth: false,
    adaptiveHeight: true,
    prevArrow: '<div class="slick-left-arrow slick-arrow"><img src="/assets/img/left-arrow-alt-min.png" class="gray-arrow" alt="Left Arrow Icon"><img src="/assets/img/left-arrow-white-min.png" class="white-arrow" alt="Left Arrow Icon"></div>',
    nextArrow: '<div class="slick-right-arrow slick-arrow"><img src="/assets/img/right-arrow-alt-min.png" class="gray-arrow" alt="Right Arrow Icon"><img src="/assets/img/left-arrow-flipped-white-min.png" class="white-arrow" alt="Right Arrow Icon"></div>'
});
